import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './Instructions.css';


const Instructions = ({ className, id, label }) => {
  return (
    <div className={cx(s.component, className)}>
      <p id={id} className={s.instructions}>{label}</p>
    </div>
  );
};

Instructions.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
};

export default Instructions;



// WEBPACK FOOTER //
// ./src/components/FormElements/Instructions/Instructions.js